'use strict';

const newsSignupModal = require('../../modules/newsSignupModal');

function controller() {
    const vm = this;

    vm.email = '';

    vm.submit = ev => {
        ev.preventDefault();

        newsSignupModal.openModal(vm.email);

        return false;
    }

    return vm;
}

module.exports = [
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/NewsSignup.js